import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

import { MerchantCleanUpComponent } from './merchant-clean-up.component';
import { MerchantCleanUpRouter } from './merchant-clean-up.router';

/** @constant {angular.module} */
const merchantCleanUpModule = angular
  .module('ec.opsCenter.ops-support.nerchant-clean-up', [])
  .config(MerchantCleanUpRouter)
  .directive('appMerchantCleanUp', downgradeComponent({ component: MerchantCleanUpComponent }) as angular.IDirectiveFactory).name;

export default merchantCleanUpModule;



// WEBPACK FOOTER //
// ./src/app/ops-support/merchant-clean-up/merchant-clean-up.module.ajs.ts